import {initWebComponent} from "@/helpers/web-component-helper";
import {createUserSession} from "@/helpers/user-session-helper";

export class BookmarkUserSessionModalComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');

        template.innerHTML = `

<!-- Modal -->
<div class="modal fade" id="mdlSession" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Bookmark toevoegen</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-row">
            <div class="form-group col">
                <label class="form-label">Naam</label>
                <input type="text" class="form-control" id="mdlEditUserSessionName" value="" autofocus>
            </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary text-transform-none" data-bs-dismiss="modal">Annuleren</button>
        <button id="btnSessionSaveModal" type="button" class="btn btn-success float-right text-transform-none" data-bs-dismiss="modal">Opslaan</button>
      </div>
    </div>
  </div>
</div>
`

        initWebComponent(this, template)

        this.querySelector('#btnSessionSaveModal').addEventListener('click', event => {
            createUserSession(this.querySelector('#mdlEditUserSessionName').value)
        })
    }
}
